import * as React from 'react';
import * as ReactDOM from 'react-dom';
import store from './store';
import Index from './view/Index';
import { Provider } from 'mobx-react';
// import { orange } from '@material-ui/core/colors';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import 'intersection-observer';
import 'babel-polyfill';
// import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
// let vConsole = new VConsole()
import '@/assets/css/reset.css';
// 整体主题配置
const outerTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#26c6da'
        },
        secondary: {
            main: '#26c6da'
        }
    }
    // overrides: {
    //     // MuiButton: {
    //     //   root: {
    //     //     fontSize: '14px',
    //     //     padding:'5px 8px'
    //     //   },
    //     // },
    // }
});
ReactDOM.render(
    <ThemeProvider theme={outerTheme}>
        <Provider {...store}>
            <Index name='/' />
        </Provider>
    </ThemeProvider>,
    document.getElementById('app') as HTMLElement
);
